import React from "react";
import { useTranslation } from "react-i18next";
import { Chip, Tooltip } from "@mui/material";
import { ClientSearchOwner } from "core/types/client-search.types";

// i18next fa di default l'escape HTML dei valori interpolati (i18n.js non lo spegne):
// un cognome come "D'Amico" uscirebbe "D&#39;Amico". Il testo lo protegge gia' React.
export const NO_ESCAPE = { escapeValue: false };

// La data arriva come la serializzano gli endpoint esistenti ("Mon, 05 Oct 2026 10:00:00
// GMT"): Date la legge gia' col fuso giusto. Ora compresa: RM crea piu' ricerche nello
// stesso giorno per lo stesso cliente.
export const fmtSearchDate = (raw: string, language?: string): string => {
  if (!raw) return "—";
  const d = new Date(raw);
  if (isNaN(d.getTime())) return raw;
  return d.toLocaleString(language?.startsWith("en") ? "en-GB" : "it-IT", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const isOwnerSuspended = (owner?: ClientSearchOwner): boolean =>
  owner?.billingStatus === "suspended";

// Cliente sospeso per mancato pagamento: l'operatore puo' comunque lavorarlo, ma deve
// saperlo prima di aprire una pratica a suo nome.
export const SuspendedChip: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t("clientSearches.suspended_tooltip")}>
      <Chip
        size="small"
        color="error"
        variant="outlined"
        label={t("clientSearches.suspended")}
      />
    </Tooltip>
  );
};
